import {apiConstants, config, requestOptions, requestTypes, sendRequest} from "../../../../Utilities/Api";

class serverBraillerQueueApi {
    static getUserQueue() {
        return sendRequest(
            requestOptions(config.URL + `braillers/queue`,
                requestTypes.GET,
            ),
        );
    }

    static addToQueue(catalogItemId: string) {
        return sendRequest(
            requestOptions(config.URL + `braillers/queue`,
                requestTypes.POST,
                JSON.stringify({BraillerCatalogItemId: catalogItemId}),
                apiConstants.successMessage.queue.ADD,
            ),
        );
    }

    static assignShippingLocation(braillerQueueAssignment: Record<string, unknown>) {
        return sendRequest(
            requestOptions(config.URL + `braillers/queue/assign-shipping`,
                requestTypes.PUT,
                JSON.stringify(braillerQueueAssignment),
                apiConstants.successMessage.queue.UPDATE,
            ),
        );
    }

    static deleteQueueItem(braillerQueueItemId: string) {
        return sendRequest(
            requestOptions(config.URL + `braillers/queue/${braillerQueueItemId}`,
                requestTypes.DELETE,
                null,
                apiConstants.successMessage.queue.DELETE
            ),
        );
    }
}

export const braillerQueueApi = config.environment.MODE === config.modes.SERVER ? serverBraillerQueueApi : serverBraillerQueueApi;